import React from "react";
import { useShellTheme } from "../layout/ShellTheme";

/** Calm on-site pricing trust — brand-safe, not marketplace-negative. */
export default function BestPriceTrustSection({ className = "" }) {
  const dark = useShellTheme() === "dark";

  return (
    <section
      className={
        dark
          ? `rounded-[2rem] border border-gold/35 bg-gradient-to-br from-gold/15 via-panel to-void p-8 md:p-10 ${className}`
          : `rounded-[2rem] border border-cream bg-gradient-to-br from-white to-cream/50 p-8 md:p-10 ${className}`
      }
      aria-labelledby="best-price-heading"
    >
      <h2
        id="best-price-heading"
        className={`font-sans font-semibold text-2xl md:text-3xl ${dark ? "text-ivory" : "text-forest"}`}
      >
        The best Moss Matrix prices are always here on our official website.
      </h2>
      <p className={`mt-4 text-sm leading-relaxed max-w-3xl ${dark ? "text-sage" : "text-botanical/85"}`}>
        We may sell through other marketplaces from time to time, but marketplace fees and delivery costs can affect
        pricing. Ordering directly from Moss Matrix helps us keep prices fair, support fresh preparation, and give
        customers the best experience.
      </p>
    </section>
  );
}
